import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../common/Style";
import {
  cancelTizmun,
  destroyUser,
  editUserById,
} from "../../store/reducers/efratReducer";
import { toast } from "react-toastify";
import YesNoModal from "../common/modals/YesNoModal";
import { CFV } from "../common/others/Functions";
import GenericModal from "../common/modals/GenericModal";
import OpacityLoading from "../common/loader/OpacityLoading";
import call from "../../assets/common/call.svg";
import whatsappW from "../../assets/common/whatsappW.svg";
import trash from "../../assets/common/trash.svg";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Msg from "./Msg";
import WelcomeMsg from "./WelcomeMsg";

const EditUser = ({ user, init, secondInit }) => {
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showTizmun, setShowTizmun] = useState(false);
  const [showWelcome, setShowWelcome] = useState(false);
  const [showAskForCancel, setShowAskForCancel] = useState(false);

  const [date, setDate] = useState(new Date(user.date));

  const onSubmit = async (data) => {
    const body = {
      ...data,
    };
    console.log("body ", body);
    dispatch(editUserById(user._id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleDestroyUser = async () => {
    setLoading(true);
    dispatch(destroyUser({ id: user._id, bridePhone: user.bridePhone })).then(
      (res) => {
        if (res.payload?.error) toast.error(res.payload?.error);
        else {
          toast.success("הפעולה בוצעה בהצלחה!");
          setShowDelete(false);
          init(null);
        }
        setLoading(false);
      }
    );
  };

  const handleCancelTizmun = async () => {
    setLoading(true);
    dispatch(cancelTizmun({ bridePhone: user.bridePhone })).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      else {
        toast.success("הפעולה בוצעה בהצלחה!");
        secondInit(null);
      }
      setLoading(false);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
      style={{ position: "relative" }}
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
          marginTop: "40px",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            padding: "5px 15px",
            borderRadius: "0 0 20px 0",
            background: "rgba(123,150,196,0.95)",
            color: "white",
            fontWeight: "bold",
          }}
        >
          {date.toISOString().replace(/T.*/, "").split("-").reverse().join("/")}
        </div>
        <FlexRowBetween>
          <div style={{ width: "35%" }}>
            <Label>שם האישה</Label>
            <Input
              defaultValue={user.brideName}
              type="text"
              {...register("brideName", {
                required: true,
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("brideName", "בין 2 ל 20 תווים", errors)}
          </div>
          <div style={{ width: "35%" }}>
            <Label>שם הגבר</Label>
            <Input
              defaultValue={user.groomName}
              type="text"
              {...register("groomName", {
                required: true,
                minLength: 0,
                maxLength: 50,
              })}
            />
            {CFV("groomName", "בין 2 ל 20 תווים", errors)}
          </div>
        </FlexRowBetween>
        <FlexRowBetween style={{ alignItems: "center" }}>
          <div style={{ width: "45%" }}>
            <Label>נייד אישה</Label>
            <Input
              defaultValue={user.bridePhone}
              {...register("bridePhone", {
                required: true,
                pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("bridePhone", "פורמט מספר פלאפון לא חוקי", errors)}
          </div>
          <div style={{ width: "45%" }}>
            {user.wasSet ? (
              <GenericDiv
                onClick={() => setShowAskForCancel(true)}
                style={{ padding: "9px", fontWeight: "bold" }}
              >
                ביטול תזמון
              </GenericDiv>
            ) : (
              <GenericDiv
                onClick={() => setShowTizmun(true)}
                style={{ padding: "9px", fontWeight: "bold" }}
              >
                יצירת תזמון
              </GenericDiv>
            )}
            {/* <Label>נייד גבר</Label>
            <Input
              defaultValue={user.groomPhone}
              {...register("groomPhone", {
                pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
              })}
            />
            {CFV("groomPhone", "פורמט מספר פלאפון לא חוקי", errors)} */}
          </div>
        </FlexRowBetween>
        <FlexRowBetween>
          {user.welcomeWasSend ? (
            <GenericDiv
              style={{
                padding: "9px",
                fontWeight: "bold",
                color: "#3a3c3f",
                background: "#f2f2f2",
                border: "2px solid gray",
              }}
            >
              הודעת הצטרפות נשלחה ✔️
            </GenericDiv>
          ) : (
            <GenericDiv
              onClick={() => setShowWelcome(true)}
              style={{
                padding: "9px",
                fontWeight: "bold",
              }}
            >
              שליחת הודעת הצטרפות
            </GenericDiv>
          )}
        </FlexRowBetween>

        <Label style={{ marginTop: "20px" }}>הערות</Label>
        <TextArea
          defaultValue={user.description}
          type="text"
          rows="3"
          {...register("description", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("description", "עד 500 תווים", errors)}

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <a
            href={
              "tel:" +
              (user.bridePhone[0] === "0"
                ? user.bridePhone
                : "0" + user.bridePhone + "")
            }
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ padding: "8px 8px" }}
            >
              <img src={call} alt={"call"} style={{ width: "23px" }} />
            </GenericDiv>
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://wa.me/972${user.bridePhone}/?text=`}
          >
            <GenericDiv
              background={"rgba(123,150,196,0.95)"}
              style={{ margin: "0 20px", padding: "4px 4px" }}
            >
              <img
                src={whatsappW}
                alt={"whatsappW"}
                style={{ width: "31px" }}
              />
            </GenericDiv>
          </a>
          <Button style={{ width: "100%" }}>שמירה</Button>
          <GenericDiv
            onClick={() => setShowDelete(true)}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {loading && <OpacityLoading />}

      {showWelcome && (
        <GenericModal
          init={setShowWelcome}
          div={
            <WelcomeMsg
              user={user}
              init={secondInit}
              selfInit={setShowWelcome}
            />
          }
        />
      )}

      {showTizmun && (
        <GenericModal
          init={setShowTizmun}
          div={<Msg user={user} init={secondInit} selfInit={setShowTizmun} />}
        />
      )}

      {showAskForCancel && (
        <GenericModal
          init={setShowAskForCancel}
          div={
            <YesNoModal
              title={"מחיקת תזמון"}
              body={"האם את/ה בטוח/ה שברצונך למחוק תזמון זה?"}
              no={setShowAskForCancel}
              yes={handleCancelTizmun}
            />
          }
        />
      )}
      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת אירוע"}
              body={"האם את/ה בטוח/ה שברצונך למחוק אירוע זה?"}
              no={setShowDelete}
              yes={handleDestroyUser}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default EditUser;
